import React from 'react';

interface Props {
  href: string;
  newTab?: boolean;
  children: React.ReactNode;
}

function FooterLink(props: Props) {
  return (
    <a href={props.href} target="_blank" className="text-p2 block text-portal-teal decoration-0 my-md hover:underline
        active:text-portal-teal visited:text-portal-teal">
      {props.children}
    </a>
  );
}

export default FooterLink;